export default "__VITE_ASSET__589f7a98__"